import { HttpClient } from '@angular/common/http';
import { TranslatePoHttpLoader } from '@biesbjerg/ngx-translate-po-http-loader';
import { map } from 'rxjs/operators';

import { APP_CONFIG } from '../settings';

export class XTranslationLoader extends TranslatePoHttpLoader {
  domain;
  constructor(
    protected _http: HttpClient,
    protected _prefix: string = '/assets/i18n/',
    protected _suffix: string = '.po'
  ) {
    super(_http, _prefix, _suffix);
  }

  getTranslation(lang: string): any {
    return this._http
      .get(`${this._prefix}${lang}${this._suffix}`, {
        params: { v: APP_CONFIG.i18n.version },
        responseType: 'text'
      })
      .pipe(map((contents: string) => this.parse(contents)));
  }
}

export function TranslateHttpLoaderFactory(http: HttpClient): TranslatePoHttpLoader {
  return new XTranslationLoader(http, '/imprint/assets/i18n/', '.po');
}



// WEBPACK FOOTER //
// ./src/config/i18n/translate-http-loader.factory.ts